export default "__VITE_ASSET__Brs_uLGe__"